const inquiryTypes = [
    {
        id: 1,
        apiName: "Innsyn",
        name: "inquiryPetition",
        text: "inquiryPetitionText",
        placeholder: "inquiryPetitionPh",
        maxInquiryLength: 200,
        pathname: "/inquiry",
        search: "?petition"
    },
    {
        id: 2,
        apiName: "Retting",
        name: "inquiryCorrectInfo",
        text: "inquiryCorrectInfoText",
        placeholder: "inquiryCorrectInfoPh",
        pathname: "/inquiry",
        search: "?correct-info"
    },
    {
        id: 3,
        apiName: "Sletting",
        name: "inquiryPersonalInfo",
        text: "inquiryPersonalInfoText",
        placeholder: "inquiryPersonalInfoPh",
        pathname: "/inquiry",
        search: "?delete-personal-data"
    },
    {
        id: 4,
        apiName: "Annet",
        name: "inquiryOther",
        text: "inquiryOtherText",
        placeholder: "inquiryOtherPh",
        pathname: "/inquiry",
        search: "?other"
    }
];

export default inquiryTypes;
